import { useState } from 'react';

/** @function
 *
 * Hook for initialising state for a given tooltip.
 *
 * Useful, as we have more than one on the page.
 * @returns {{tooltipState: {posX: number, posY: number, selectedDot: null, hovered: boolean, selected: boolean}, clearTooltip: clearTooltip, setTooltipState: (value: (((prevState: {posX: number, posY: number, selectedDot: null, hovered: boolean, selected: boolean}) => {posX: number, posY: number, selectedDot: null, hovered: boolean, selected: boolean}) | {posX: number, posY: number, selectedDot: null, hovered: boolean, selected: boolean})) => void}}
 */
export function useTooltip() {
    const initialTooltipState = {
        selected: false,
        hovered: false,
        posX: 0,
        posY: 0,
        selectedDot: null
    };
    const [tooltipState, setTooltipState] = useState(initialTooltipState);
    const clearTooltip = () => {
        setTooltipState(initialTooltipState);
    };

    return { tooltipState, setTooltipState, clearTooltip };
}
